export const IMAGE_PLACEHOLDER: string = '/icons/comb.svg';
export const AVATAR_PLACEHOLDER: string = '/images/avatar.png';
export const HAIRSTYLE_PLACEHOLDER: string = '/icons/hairstyle-placeholder.svg';

export const placeOfReceptions: {label: string, value: string}[] = [
  {label: 'At my home', value: 'dom_utlr'},
  {label: 'At the hairdresser\'s', value: 'dom_coifr'},
  {label: 'Everywhere', value: 'everywhere'}
];

export const SEX_OPTIONS = [
  {label: 'Male', value: 'M'},
  {label: 'Female', value: 'F'}
];
